/**
 * Single Service – FAQ accordion and Read more toggle.
 * Uses jQuery. Event delegation so accordion works when script runs.
 *
 * @package Naari
 */

(function ($) {
	'use strict';

	if (typeof $ === 'undefined') return;

	/**
	 * FAQ accordion: one open at a time. On trigger click, close any other open panel then open the clicked one (or close it if already open).
	 */
	function initFaqAccordion() {
		$(document).on('click', '.sec-service-single [data-accordion-trigger]', function (e) {
			e.preventDefault();
			var $btn = $(this);
			var $item = $btn.closest('[data-accordion-item]');
			var $panel = $item.find('.accordion__panel');
			var $accordion = $item.closest('.accordion');

			if (!$panel.length || !$accordion.length) return;

			var isCurrentlyOpen = !$panel[0].hidden;

			// Close all other open panels in this accordion (so only one is open)
			$accordion.find('[data-accordion-item]').each(function () {
				var $other = $(this);
				if ($other[0] === $item[0]) return;
				var $otherPanel = $other.find('.accordion__panel');
				var $otherBtn = $other.find('[data-accordion-trigger]');
				if ($otherPanel.length && !$otherPanel[0].hidden) {
					$otherPanel.prop('hidden', true);
					$otherBtn.attr('aria-expanded', 'false');
					$other.removeAttr('data-open');
				}
			});

			if (isCurrentlyOpen) {
				$panel.prop('hidden', true);
				$btn.attr('aria-expanded', 'false');
				$item.removeAttr('data-open');
			} else {
				$panel.prop('hidden', false);
				$panel.removeAttr('hidden');
				$btn.attr('aria-expanded', 'true');
				$item.attr('data-open', '');
			}
		});
	}

	/**
	 * Read more / Read less toggle for intro content.
	 */
	function initReadMore() {
		$(document).on('click', '.sec-service-single .js-service-single-read-more', function (e) {
			e.preventDefault();
			var $wrap = $(this).closest('.sec-service-single');
			var $btn = $(this);
			var $more = $wrap.find('.js-service-single-more');

			if (!$more.length) return;

			var isExpanded = $btn.attr('aria-expanded') === 'true';
			$more.prop('hidden', isExpanded);
			$btn.attr('aria-expanded', isExpanded ? 'false' : 'true');
			var labels = window.naariServiceSingle || {};
			$btn.text(isExpanded ? (labels.readMore || 'Read More') : (labels.readLess || 'Read Less'));
		});
	}

	/**
	 * Desktop: keep right column height equal to the image column.
	 * If content is taller, the right column scrolls (CSS uses --ss-media-h).
	 */
	function initEqualHeightScroll() {
		var $section = $('.sec-service-single');
		if (!$section.length) return;

		var rafId = 0;
		var tId = 0;

		function measureAndSet() {
			var isDesktop = window.matchMedia && window.matchMedia('(min-width: 1025px)').matches;
			var $inner = $section.find('.service-single__inner').first();
			var $media = $section.find('.service-single__media').first();
			var $img = $section.find('.service-single__img').first();
			if (!$inner.length || !$media.length) return;

			if (!isDesktop) {
				$inner[0].style.removeProperty('--ss-media-h');
				return;
			}

			// Prefer the actual rendered image height; media wrapper can include extra space.
			var h = 0;
			if ($img.length && $img[0] && $img[0].getBoundingClientRect) {
				h = $img[0].getBoundingClientRect().height;
			}
			if (!h || h < 1) {
				h = $media[0].getBoundingClientRect().height;
			}
			if (!h || h < 1) return;
			var px = Math.round(h) + 'px';
			$inner[0].style.setProperty('--ss-media-h', px);
			$section[0].style.setProperty('--ss-media-h', px);
		}

		function scheduleMeasure() {
			if (rafId) return;
			rafId = window.requestAnimationFrame(function () {
				rafId = 0;
				measureAndSet();
			});
		}

		function debouncedMeasure() {
			window.clearTimeout(tId);
			tId = window.setTimeout(function () {
				scheduleMeasure();
			}, 120);
		}

		// Initial measure (after layout/images).
		scheduleMeasure();
		window.setTimeout(scheduleMeasure, 0);
		window.setTimeout(scheduleMeasure, 250);

		// Re-measure on resize and after UI changes.
		$(window).on('resize', debouncedMeasure);
		$(document).on('click', '.sec-service-single [data-accordion-trigger]', debouncedMeasure);
		$(document).on('click', '.sec-service-single .js-service-single-read-more', debouncedMeasure);

		// If image loads later (lazy), re-measure.
		$section.find('.service-single__img').on('load', debouncedMeasure);
	}

	function init() {
		initFaqAccordion();
		initReadMore();
		initEqualHeightScroll();
	}

	$(function () {
		init();
	});
})(jQuery);
